import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbModule } from '@michelin/theme';
import { AccessibilityStatementComponent } from './components/accessibility-statement/accessibility-statement.component';

@NgModule({
  declarations: [AccessibilityStatementComponent],
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, BreadcrumbModule],
  exports: [AccessibilityStatementComponent]
})
export class HelpModule {}
